module.exports = __webpack_public_path__ + "hero.jpg?9945be7c9bfdda9d55c8766f8305ad52";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dist/hero.jpg
// module id = 409
// module chunks = 1